import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getPhoneLine = (phoneLineId: number | undefined): Promise<IGetPhoneLineViaID> => {
  return axiosDefaultApi.get(`/api/ComLines/GetComLineViaID/PhoneLine/${phoneLineId}`);
};

type QueryFnType = typeof getPhoneLine;

type UseGetPhoneLineOptions = {
  phoneLineId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetPhoneLine = ({ phoneLineId , config }: UseGetPhoneLineOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getPhoneLine_${phoneLineId}`],
    queryFn: () => getPhoneLine(phoneLineId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση της τηλεφωνικής γραμμής.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};